exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.do-not-show {\n\tdisplay: none !important;\n}\n.needs-upgrade {\n    border: solid 2px #20b4a8;\n    transition: border 0.5s;\n}\n", ""]);

// exports
